var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{attrs:{"type":"flex","gutter":16}},[_c('a-col',{attrs:{"span":24}},[(!_vm.loading)?_c('media-analyze',{attrs:{"analisis":_vm.analisis,"post":_vm.post}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }